export default __webpack_public_path__ + "static/media/settings.3e8bf9d5.svg";